module.exports = __webpack_public_path__ + "static/index/img/baikal-904.253a764d.jpg";